import { createPortal } from 'react-dom';
import { motion, AnimatePresence } from 'motion/react';
import { LoaderCircle } from 'lucide-react';

// SOK-17: mientras se procesa una lectura del escáner la pantalla se oscurece y no acepta toques,
// para que se note que hay que esperar. Queda bajo las notificaciones (#notification-root).
// SOK-33: también bloquea la pantalla mientras se prueba el POS, con otro mensaje.
export function ScanOverlay({ open, message = 'Buscando producto...' }) {
  return createPortal(
    <AnimatePresence>
      {open ? (
        <motion.div
          key="scan-overlay"
          className="fixed inset-0 z-[99990] flex items-center justify-center bg-black/30 cursor-wait"
          role="status"
          aria-live="polite"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.15 }}
          onPointerDown={(e) => { e.preventDefault(); e.stopPropagation(); }}
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}
        >
          <div className="flex items-center gap-4 rounded-2xl px-10 py-6 shadow-xl" style={{ backgroundColor: 'var(--card)', color: 'var(--card-foreground)' }}>
            <div className="spin">
              <LoaderCircle width={36} height={36} />
            </div>
            <p className="secondary-font-bold text-2xl">{message}</p>
          </div>
        </motion.div>
      ) : null}
    </AnimatePresence>,
    document.body
  );
}
